import { Link } from "react-router-dom";
import { PhoneCall, Stethoscope, HeartPulse, Home as HomeIcon, Users, BookOpen } from "lucide-react";

/**
 * Slow-scrolling resource menu ticker rendered above the site footer.
 * Six fixed categories. Each item deep-links into the Resources page.
 */
const CATEGORIES = [
  { slug: "helpline",    label: "National Helpline",             icon: PhoneCall,   accent: "var(--terracotta)" },
  { slug: "detox",       label: "Detox Facilities",              icon: Stethoscope, accent: "var(--forest)"     },
  { slug: "programs",    label: "In & Out-Patient Programs",     icon: HeartPulse,  accent: "var(--terracotta)" },
  { slug: "sober-living",label: "Sober Livings",                 icon: HomeIcon,    accent: "var(--forest)"     },
  { slug: "meetings",    label: "12-Step Meeting Schedules",     icon: Users,       accent: "var(--terracotta)" },
  { slug: "other",       label: "Other Resources",               icon: BookOpen,    accent: "var(--forest)"     },
];

function TickerRow({ ariaHidden = false }) {
  return (
    <div className="flex items-center gap-10 whitespace-nowrap px-6" aria-hidden={ariaHidden || undefined}>
      {CATEGORIES.map(({ slug, label, icon: Icon, accent }, i) => (
        <Link
          key={`${slug}-${i}`}
          to={`/resources#${slug}`}
          data-testid={ariaHidden ? undefined : `ticker-${slug}`}
          className="group inline-flex items-center gap-2.5 py-3 text-[13px] md:text-sm text-[var(--ink-soft)] hover:text-[var(--ink)] transition-colors"
        >
          <span
            className="inline-flex items-center justify-center w-7 h-7 rounded-full shrink-0"
            style={{ background: accent, color: "#fff" }}
          >
            <Icon className="w-3.5 h-3.5" strokeWidth={1.75} />
          </span>
          <span className="tracking-wide font-medium group-hover:underline underline-offset-4">{label}</span>
          <span className="text-[var(--line)]" aria-hidden="true">•</span>
        </Link>
      ))}
    </div>
  );
}

export default function ResourceTicker() {
  return (
    <div
      className="border-t border-b border-[var(--line)] overflow-hidden"
      style={{ background: "var(--bg-alt)" }}
      data-testid="resource-ticker"
      aria-label="Recovery resources menu"
    >
      <div className="flex items-center">
        <div className="marquee-track flex items-center">
          <TickerRow />
          <TickerRow ariaHidden />
        </div>
      </div>
    </div>
  );
}
